import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, Grid, IconButton, Modal, TextField, ThemeProvider, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import brokerGroupApi from "../../../api/brokerGroupApi";
import { ContextNotification, severitys } from "../../../App";
import { ContextUserInfo } from "../../../Layout/MainLayout";
import AccessControl from "../../../Components/AccessControl";
import RtlProvider from "../../../Components/RtlProvider";
import AddPassengerToFlight from "./AddPassengerToFlight";
import ConfirmFlightStepper from "./ConfirmFlightStepper";
import CustomTitle from "../../../Components/CustomTitle";


const FlightPassenger = ({ row, RefreshGrid }) => {

  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { setOpen } = useContext(ContextNotification);
  const [openedGroupKey, setOpenedGroupKey] = useState(null);
  const [groupsData, setGroupsData] = useState([]);
  const [selectedFlightId, setSelectedFlightId] = useState(null);


  const ResetForm = () => {
    setOpenedGroupKey(null);
    setOpenConfirmFlight(false);
    setSelectedFlightId(null);
    GetGroupsData();
    RefreshGrid();

  }
  const GetGroupsData = () => {

    brokerGroupApi.GetFlightGroupsAndPassengers(row.flightId)
      .then((res) => {
        setGroupsData(res.data.data);
      }
      )
      .catch(err => {

            if (err.status === 401) {
                localStorage.clear();
                window.location.pathname = "/login";
            }
            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: ' خطا در عملیات: ' + JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        }
      )
  }
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  useEffect(() => {
    GetGroupsData();
    setFilterPassengerName(null);
    setFilterSSn(null);
  }, [row]);

  //confirm flight
  //style
  const modalStyle = {
    position: 'absolute',
    overflowX: 'auto',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 750,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    pt: 2,
    px: 2,
    pb: 2,
    height: 560,
    overflow: 'scroll',
  };
  const modalStyleMobile = {
    position: 'absolute',
    overflowX: 'auto',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    pt: 2,
    px: 2,
    pb: 2,
    maxheight: 500,

    overflowY: 'scroll',
  };


  const [openConfirmFlight, setOpenConfirmFlight] = useState(false);
  const HandleOpenConfirmFlight = () => {

    setOpenConfirmFlight(true);
  }
  const HandleCloseConfirmFlight = () => {
    setOpenConfirmFlight(false);
  }
  const [filterPassengerName, setFilterPassengerName] = useState(null);
  const [filterSSn, setFilterSSn] = useState(null);
  const handleFilterPassenger = (event) => {
    var fullname = event.target.value;
    if (!(fullname) || (fullname.trim() === ''))
      setFilterPassengerName(null)
    else if (Number(fullname.trim())) {
      setFilterSSn(fullname.trim())
      setFilterPassengerName(null);
    }
    else {
      setFilterSSn(null);
      setFilterPassengerName(fullname.trim());
    }
  }

  const getMaxGroupIndex = () => {
    return (groupsData?.tripGroupMembersResponses ? groupsData.tripGroupMembersResponses.length : 0);
  }
  return (
    <>
      <RtlProvider>
        <Box
          sx={{

            margin: 'auto',

            width: '100%',
          }}
        >
          <Typography variant="h4" gutterBottom component="div" style={{ textAlign: "right", m: 2 }}>
            لیست کاروان های پرواز
          </Typography>

          {(row.flightDateReal === null) && AccessControl.checkPermissions(userPermissions, ["Flight:ConfirmFlight"]) && <Button color="secondary" onClick={() => {
            HandleOpenConfirmFlight();
          }}>
            تایید پرواز
          </Button>}

          {(row.flightDateReal !== null) && AccessControl.checkPermissions(userPermissions, ["Flight:EditConfirmedFlight"]) && <Button color="secondary" onClick={() => {
            HandleOpenConfirmFlight();
          }}>
            ویرایش پرواز تایید شده
          </Button>}
          <Modal
            keepMounted
            open={openConfirmFlight}
            onClose={HandleCloseConfirmFlight}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={(isMobile ? modalStyleMobile : modalStyle)}>
             <RtlProvider>
             <Typography component="h1" variant="h3" sx={{ display: "flex",  fontSize: '16px' ,dir:'ltr'}}>
                <p> {(row.tripTypeTitle?' پرواز '+row.tripTypeTitle+' - ':'')+(row.flightNo?row.flightNo+' - ':'') }</p>
             <p sx={{dir:'ltr'}}>{(row.flightDatePersian?row.flightDatePersian+' - ':'') +(row.flightTime?row.flightTime+' ':'')} </p>
            </Typography>
            </RtlProvider>
            <div style={{marginBottom:25,height:3,background:'#81B214',}}/>
         
            <Box>
              <Typography id="modal-modal-description" sx={{ mt: 1 }}>

                {/* <ConfirmFlight row={row} resetForm={ResetForm} /> */}
                <ConfirmFlightStepper row={row} isEdit={row.flightDateReal !== null} refresh={() => {
                  HandleCloseConfirmFlight();
                  RefreshGrid();
                }
                } />
                <Button typ onClick={HandleCloseConfirmFlight}>بستن</Button>
              </Typography>
            </Box>
            </Box>
          </Modal>

          {groupsData.flightGroupMembersResponses && <Typography variant="h5" gutterBottom component="div" style={{ textAlign: "right" }}>
            <TextField variant="outlined" label=" جستجوی نام/کدملی زائر" sx={{ ml: 2 }} onChange={handleFilterPassenger}>
            </TextField></Typography>}

          {groupsData.flightGroupMembersResponses?.map((tripGroupMember, index) => {
            return (
              <Box sx={{ p: 1 }}>
                <Typography variant="h5" gutterBottom component="div" style={{ textAlign: "right" }}>
                  <Tooltip title=" مشاهده لیست مسافران کاروان" placement="top">
                    <IconButton onClick={() => {
                      setOpenedGroupKey(openedGroupKey === (index + 1) ? null : index + 1);
                    }}>
                      {((openedGroupKey) && (openedGroupKey === index + 1)) ? (
                        <FaChevronUp stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                      ) : (
                        <FaChevronDown stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                      )
                      }
                    </IconButton>
                  </Tooltip>
                  {( tripGroupMember.brokerCode + ' - ' + tripGroupMember.groupNo + ' - ' + tripGroupMember.brokerName )
                    + ' ( ' + ((row.flightDateReal !== null) ? String(tripGroupMember.tripPassengerMembersResponses ? tripGroupMember.tripPassengerMembersResponses.filter(pass => ((pass.flightAttendanceStatus === null) || (pass.flightAttendanceStatus === true))).length : 0)
                      : String(tripGroupMember.tripPassengerMembersResponses ? tripGroupMember.tripPassengerMembersResponses.length : 0)) + ' )'}
                </Typography>
                {((openedGroupKey) && (openedGroupKey === index + 1)) &&
                  <table border={1} cellSpacing={0} cellPadding={4} style={{ textAlign: "center" }}>
                    <thead style={{ backgroundColor: 'rgba(233, 245, 202, 0.9)' }}>
                      <th> کد ملی</th>
                      <th> نام و نام خانوادگی</th>
                    </thead>
                    <tbody>

                      {tripGroupMember.tripPassengerMembersResponses?.filter(p => ((p.flightAttendanceStatus === null) || (p.flightAttendanceStatus === true))).filter(pass => (((!filterPassengerName) && (!filterSSn)) || (pass.fullName.includes(filterPassengerName) || pass.sSn.includes(filterSSn)))).map((Passenger) => (
                        <tr>
                          <td>{Passenger.sSn}</td>
                          <td>{Passenger.fullName}</td>
                        </tr>
                      ))
                      }

                    </tbody>
                  </table>
                }
              </Box>
            );
          }
          )}
           {(groupsData.flightPassengerMembersResponses?.length > 0) &&
            <Box sx={{ p: 1,ml:1 }}>
              <Typography variant="h5" gutterBottom component="div" style={{ textAlign: "right" }}>
                <Tooltip title=" مشاهده لیست مسافران آزاد" placement="top">
                  <IconButton onClick={() => {
                    setOpenedGroupKey(openedGroupKey === -100? null : -100);
                  }}>
                    {((openedGroupKey) && (openedGroupKey === -100)) ? (
                      <FaChevronUp stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                    ) : (
                      <FaChevronDown stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                    )
                    }
                  </IconButton>
                </Tooltip>
                {'لیست مسافران آزاد' + ' ( ' + String(groupsData.flightPassengerMembersResponses?.length) + ' )'}

              </Typography>
              {((openedGroupKey) && (openedGroupKey === -100)) &&
                <table border={1} cellSpacing={0} cellPadding={4} style={{ textAlign: "center" }}>
                  <thead style={{ backgroundColor: 'rgba(233, 245, 202, 0.9)' }}>
                    <th> کد ملی</th>
                    <th> نام و نام خانوادگی</th>
                    <th>نوع مسافر</th>

                  </thead>
                  <tbody>

                    {groupsData.flightPassengerMembersResponses?.filter(pass => (((!filterPassengerName) && (!filterSSn)) || (pass.fullName.includes(filterPassengerName) || pass.sSn.includes(filterSSn)))).map((Passenger) => (
                      <tr>
                        <td>{Passenger.sSn}</td>
                        <td>{Passenger.fullName}</td>
                        <td>{Passenger.brokerTypeTitle}</td>
                      </tr>
                    ))
                    }

                  </tbody>
                </table>}
            </Box>
          }
          
          {(groupsData.flightGuests?.length > 0) &&
            <Box sx={{ p: 1,ml:1 }}>
              <Typography variant="h5" gutterBottom component="div" style={{ textAlign: "right" }}>
                <Tooltip title=" مشاهده لیست مسافران میهمان" placement="top">
                  <IconButton onClick={() => {
                    setOpenedGroupKey(openedGroupKey ===-200 ? null : -200);
                  }}>
                    {((openedGroupKey) && (openedGroupKey === -200)) ? (
                      <FaChevronUp stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                    ) : (
                      <FaChevronDown stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                    )
                    }
                  </IconButton>
                </Tooltip>
                {'لیست مسافران میهمان' + ' ( ' + String(groupsData.flightGuests?.length) + ' )'}

              </Typography>
              {((openedGroupKey) && (openedGroupKey === -200)) &&
                <table border={1} cellSpacing={0} cellPadding={4} style={{ textAlign: "center" }}>
                  <thead style={{ backgroundColor: 'rgba(233, 245, 202, 0.9)' }}>
                    <th> کد ملی</th>
                    <th> نام و نام خانوادگی</th>
                    <th>نوع میهمان</th>
                  </thead>
                  <tbody>

                    {groupsData.flightGuests?.filter(pass => (((!filterPassengerName) && (!filterSSn)) || (pass.fullName.includes(filterPassengerName) || pass.sSn.includes(filterSSn)))).map((Passenger) => (
                      <tr>
                        <td>{Passenger.sSn}</td>
                        <td>{Passenger.fullName}</td>
                        <td>{Passenger.typeTitle}</td>
                      </tr>
                    ))
                    }

                  </tbody>
                </table>}
            </Box>
          }

        </Box>
      </RtlProvider>
    </>
  )
}
export default FlightPassenger;